module.exports = __webpack_public_path__ + "img/744.41a142a5.jpg";